<template>
  <div class="breadcrumb">
    <div class="location-name">
      当前位置: 
    </div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item class="breadcrumb-name">{{ rootMenu.name }}</el-breadcrumb-item>
      <el-breadcrumb-item class="breadcrumb-name" v-for="(pathName, idx) in path" :key="idx">{{ pathName }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: mapState(['rootMenu', 'path'])
}
</script>

<style lang='less' scoped>
.breadcrumb{
  display: flex;
  .location-name{
    margin-right:5px;
    font-size: 14px;
    font-weight: bold;
    span{color: #ffb400;}
  }
}
</style>